'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('webaccess-show', {
      url: '/webaccess/:id',
      template: '<webaccess-show></webaccess-show>',
      authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/webaccess/show/webaccess-show.routes.js